export default "__VITE_ASSET__CQohkcEw__"